module.exports = __webpack_public_path__ + "static/media/UnlockedBy.fc4539ed.png";